export default {
    EDIT_PROFILE: 'EDIT_PROFILE',
    GET_PROFILE: 'GET_PROFILE',
}